import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CardPedido } from './CardPedido';
import { CardNotFound } from './CardNotFound';
import ErrorIcon from '@material-ui/icons/Error';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding:'1rem'
  },
}));


export const Inicio = (props) => {
  const classes = useStyles();
  const data = props.arr;
  const ids = props.busqueda;  
  return (
    <div className={classes.root}>
{
  ids.map((elem, i)=>{
    if( elem.contador === 1 ){
      return(
        <CardPedido elem={data[elem.ubic[0]]} key={elem.id} />
      )
    }else  if(elem.contador === 0){
      return(
        <CardNotFound id={elem.id} key={elem.id} />
      )
    }else{
      return(
        <div style={{ border:'1px solid #CCCCCC', marginTop:'5vh', borderRadius:'10px', paddingLeft:'15px', paddingRight:'15px', width:'90vw', paddingBottom:'5vh',boxShadow: '2px 5px 28px -14px rgba(0,0,0,0.26)'}}>
          <div style={{ fontSize:'1.5rem', color: '#58595B', margin: '1rem'}}>
            {elem.id}
          </div>
          <div style={{ fontSize:'1rem', color: '#58595B', margin: '1rem', display:'flex', alignItems:'center'}}>
            <ErrorIcon /> Encontramos varios resultados para este pedido
          </div>
          {
             (elem.ubic).map((item)=> <CardPedido elem={data[item] } key={item} />)
          }
          </div>
      )}
  })
}
    </div>
  );
};

